import { ChangeDetectionStrategy, Component, HostBinding, HostListener, Input, OnChanges } from '@angular/core';

import { EventMediaHelperService } from '@frontend/sports/betting-offer/feature/media';
import { EventDetailsColumnType, EventModel, EventScoreboard } from '@frontend/sports/betting-offer/feature/model';
import { getStatsIcon } from '@frontend/sports/common/core/feature/icon';
import { MediaEventSource } from '@frontend/sports/grid/media/feature/model';
import { MediaApiService } from '@frontend/sports/grid/media/feature/state';
import { TrackingVideoSource } from '@frontend/sports/tracking/feature';
import { DeviceService } from '@frontend/vanilla/core';

import { BetRadarStatisticsService } from '../../bet-radar/bet-radar-statistics.service';

@Component({
    selector: 'ms-statistics-button',
    template: '<i [ngClass]="actual"></i><i [ngClass]="hover"></i>',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class StatisticsButtonComponent implements OnChanges {
    @Input() event: EventModel;
    @Input() scoreboard: EventScoreboard;
    @HostBinding('class') className = 'statistics-button';
    @HostBinding('class.hidden') hidden = false;

    actual = `${getStatsIcon(false)} actual`;
    hover = `${getStatsIcon(true)} hover`;

    constructor(
        private helper: EventMediaHelperService,
        private betRadarStatistics: BetRadarStatisticsService,
        private device: DeviceService,
        private mediaApi: MediaApiService,
    ) {}

    ngOnChanges(): void {
        this.hidden = this.device.isMobile || !this.helper.hasStats(this.event);
    }

    @HostListener('click')
    clicked(): void {
        if (this.hidden) {
            return;
        }

        this.setStatistics();

        if (this.event.statsId) {
            this.betRadarStatistics.open(this.event.statsId);
        }
    }

    private setStatistics(): void {
        this.mediaApi.setEvent(this.event, MediaEventSource.Scoreboard, EventDetailsColumnType.Stats, TrackingVideoSource.EventDetails);
    }
}
